import { IAdvancedRichText } from '../../../../../../inputs';
import { IBaseWidget } from '../../../../IBaseWidget';

interface ITableColumnWidget extends IBaseWidget {
  label?: IAdvancedRichText;

  /**
   * Campo calcolato per side-effect sul widget stesso della colonna a runtime
   * per indicare se almeno una delle celle della colonna ha un virtualRef
   * al suo interno.
   */
  // __hasVirtualColumnRefs?: boolean;
}

export function isTableColumnWidget(
  widget: IBaseWidget,
): widget is ITableColumnWidget {
  return 'label' in widget && widget.layout?.isTableColumn === true;
}
